/** @format */

import moment from 'moment';
import 'moment-timezone';

import template from './gb-edit-countdown-widget.html';
import './gb-edit-countdown-widget.scss';

export const GbEditCountdownWidgetComponent = {
    template,
    require: {
        gbEditTools: '^^',
        form: '^^',
        gbApp: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditCountdownWidgetComponent {
        constructor() {
            'ngInject';
        }

        $onInit() {
            this.getNow();
            this.modelOptions = {
                timezone: this.getUTCOffset(),
            };
        }

        getNow() {
            let momentNow = moment(new Date(), this.gbApp.getAuction().timezone).format('YYYY-MM-DDTHH:mm:ssZ');
            this.now = new Date(momentNow);
            this.now.setMilliseconds(0);
            this.now.setSeconds(0);
            return this.now;
        }

        isValidCountdown() {
            if (!this.getWidget().end) {
                this.getWidget().end = this.getNow();
            }
        }

        onChange() {
            this.isValidCountdown();
            return this.gbEditTools.saveWidget();
        }

        getUTCOffset() {
            return moment(new Date(), this.gbApp.getAuction().timezone).format('Z').replace(':', '');
        }

        getWidget() {
            return this.widget;
        }
    },
};
